import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.string })),
    PropTypes.arrayOf(PropTypes.string)
]);
